<template>
  <div class="photo-box">
    <div class="border-card">
      <h3>舌照</h3>
      <p>请上传舌苔和舌底的清晰照片</p>

      <div>
        <div class="upload-img" v-for="(item,index) in tongue" :key="index" v-if="index<9">
          <img :src="item" alt />
        </div>

        <div class="upload-img up-loading" v-if="sheloading">
          <img src="../../../static/icons/loading.gif" />
        </div>
        <div class="upload-img" v-if="tongue.length<9">
          <i class="icon icon-add-add"></i>
          <input type="file" accept="image/*" @change="changeShe('tongue')" ref="tongue" />
        </div>
      </div>

      <br class="clear" />
      <ul class="she-shuoming">
        <li>请在光线充足的室内，使用后置摄像头拍摄</li>
        <li>在距离面部约20cm处（一前臂距离）拍摄舌照</li>
        <li>拍摄时关闭美颜功能。注意对焦至舌头</li>
        <li>拍舌苔时，舌头向下伸长：拍舌底时，舌头向上抬起</li>
      </ul>

      <div class="shili">
        <img src="../../../static/icons/shetou@3x.png" alt />
      </div>
    </div>

    <div class="border-card">
      <h3>面照</h3>
      <p>请上传正面素颜彩色照片，如需要也可拍摄其他患部照片</p>
      <div>

        <div class="upload-img" v-for="(item,index) in faceimg" :key="index" v-if="index<9">
          <img :src="item" alt />
        </div>

        <div class="upload-img up-loading" v-if="mianloading">
          <img src="../../../static/icons/loading.gif" />
        </div>

        <div class="upload-img" v-if="faceimg.length<9">
          <i class="icon icon-add-add"></i>
          <input type="file" accept="image/*" @change="changeShe('faceimg')" ref="faceimg" />
        </div>
      </div>
      <br class="clear" />

      <ul class="she-shuoming">
        <li>自然光线下面部素颜彩色照片，如有需要也可拍摄其他患部照片</li>
      </ul>

      <div class="shili">
        <img src="../../../static/icons/mianbu@3x.png" alt />
      </div>
    </div>

    <div class="border-card" style="padding-bottom: 0.5rem">
      <h3>其它资料</h3>
      <p class="other-data">如有相关的检验报告或化验单，请上传照片，以便医生更准确的为您诊疗</p>
      <div>

        <div class="upload-img" v-for="(item,index) in otherimg" :key="index" v-if="index<9">
          <img :src="item" alt />
        </div>

        <div class="upload-img up-loading" v-if="qiloading">
          <img src="../../../static/icons/loading.gif" />
        </div>
        <div class="upload-img" v-if="otherimg.length<9">
          <i class="icon icon-add-add"></i>
          <input type="file" accept="image/*" @change="changeShe('otherimg')" ref="otherimg" />
        </div>
      </div>
      <br class="clear" />
    </div>

    <div class="bottom">
      <div class="btns">
        <button class="prop-btn" @click="subwenzhen(1)">跳过此步骤</button>
        <button class="submit-btn" @click="subwenzhen(2)">发送给医生</button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../request/http";

export default {
  name: "up_photos",
  data() {
    return {
      tongue: [],
      faceimg: [],
      otherimg: [],
      sheloading:false,
      mianloading:false,
      qiloading:false
    };
  },
  methods: {
    subwenzhen(type) {
      let pdata = this.$route.params;
      if (type == 2) {
        if (this.tongue.length == 0) {
          this.$toast.center("请上传舌照");
          return;
        }
        if (this.faceimg.length == 0) {
          this.$toast.center("请上传面照");
          return;
        }
      }

      pdata.tongue = this.tongue;
      pdata.faceimg = this.faceimg;
      pdata.otherimg = this.otherimg;
      http.post("/api/wap/case/edit", pdata).then((res) => {
        console.log(res);
        if (res.errno == 0) {
          this.$router.push("/chat_list");
        } else {
          this.$toast.center(res.errmsg);
        }
      });
    },
    changeShe(dataname) {
      let inputDOM;
      let imglist;
      switch (dataname) {
        case "tongue":
          inputDOM = this.$refs.tongue;
          imglist = this.tongue;
          this.sheloading = true;
          break;
        case "faceimg":
          inputDOM = this.$refs.faceimg;
          imglist = this.faceimg;
          this.mianloading = true;
          break;
        case "otherimg":
          inputDOM = this.$refs.otherimg;
          imglist = this.otherimg;
          this.qiloading = true;
          break;
      }
      if (imglist.length < 8) {
        let file = inputDOM.files[0]; // 通过DOM取文件数据
        let size = Math.floor(file.size / 1024); //计算文件的大小
        let formData = new FormData(); //new一个formData事件
        formData.append("file", file); //将file属性添加到formData里
        http.postFormData("/api/wap/public/upload", formData).then((res) => {
          imglist.push(res.data.path);
          this.sheloading = false;
          this.mianloading = false;
          this.qiloading = false;
        });
      } else {
        this.$toast.center("最多上传8张图片");
      }
    },
  },
};
</script>

<style scoped>
  @import './up_photos.css';
</style>



// WEBPACK FOOTER //
// src/pages/user/up_photos.vue